import React, { useState } from "react";

import { BugReportModal } from "./BugReportModal";

export const BugReportButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <a
        role="button"
        tabIndex={0}
        data-testid="bug-report-button"
        className="tw-flex tw-cursor-pointer tw-items-center"
        onClick={(): void => setIsOpen(true)}
        onKeyDown={(e): void => {
          if (e.key === "Enter" || e.key === " ") {
            setIsOpen(true);
          }
        }}
      >
        <i className="material-icons tw-mr-2 tw-text-lg tw-leading-[1]">
          bug_report
        </i>
        Report a bug
      </a>
      {isOpen && <BugReportModal onClose={(): void => setIsOpen(false)} />}
    </>
  );
};
